// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"777":"cc6c8c4f","851":"34a666df","911":"df6c0ca4"}[chunkId] + ".chunk.css";
};